import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuthStore } from '../../store/authStore';

/**
 * Routes for staff only. Signed out goes to the login page and comes back
 * afterwards; signed in without staff rights goes to the job board. The API
 * enforces the same rule, so this only keeps the page out of the way.
 */
const StaffRoute: React.FC = () => {
  const user = useAuthStore((state) => state.user);
  const loadUser = useAuthStore((state) => state.loadUser);
  const location = useLocation();

  // A session saved before `is_staff` existed does not say either way: ask
  // the server once before deciding.
  const unknown = Boolean(user) && typeof user?.is_staff !== 'boolean';
  const [asked, setAsked] = useState(false);
  useEffect(() => {
    if (!unknown || asked) return undefined;
    let current = true;
    loadUser().finally(() => {
      if (current) setAsked(true);
    });
    return () => {
      current = false;
    };
  }, [unknown, asked, loadUser]);

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (unknown && !asked) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress aria-label="Checking access" />
      </Box>
    );
  }
  if (user.is_staff !== true) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default StaffRoute;
